import type { ComponentProps } from "react";

interface CardProps extends ComponentProps<"div"> {
  raised?: boolean;
  isBlack?: boolean;
}

export function Card({ raised = false, isBlack = false, className = "", ...props }: CardProps) {
  const background = raised ? "bg-rs-jet" : isBlack ? "bg-rs-black" : "bg-rs-off-black";
  return (
    <div
      className={`${background} border border-rs-jet rounded-lg p-[22px] ${className}`}
      {...props}
    />
  );
}
